import { useState, useEffect } from 'react';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { Modal } from '../../../theme/Component/Modal';
import { _FinancialTax } from '../../../../core/services/dataBean/EntityCatalogVdos';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const FinancialTaxSchemeCatalog = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_FinancialTax)
    const [id, setID] = useState(null);

    const modal = useModal("Tipo de Impuesto Financiero", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDTaxScheme == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getFinancialTaxSchemeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDTaxScheme', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Codigo', property: 'Code', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Tipo de Impuesto Financiero"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDTaxScheme); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}